const CommunityChat = (app) => {
  app
    .post(
      "/community-chat/create-channel",
      async ({ req, res, flash, api, assert, locals }) => {
        const { body } = req;
        const { subject } = body;
        const { activeUser } = locals;

        assert(subject, 400, "You need to provide the name of the channel");

        const bodyToSend = {
          ...body,
          ownerId: String(activeUser._id),
        };

        try {
          await api(`create-chat-channel`, {
            method: "POST",
            body: bodyToSend,
          });

          flash("success", "Channel created successfully");
        } catch (e) {
          flash("error", e.message);
        }
        res.redirect("/coaching-portal/community-chat");
      }
    )
    .post("/community-chat/refresh", async ({ res }) => {
      res.backDontScroll();
    })
    .post(
      "/community-chat/modify-conversation",
      async ({ req, res, flash, api }) => {
        const { body } = req;
        try {
          await api(`modify-conversation`, {
            method: "PUT",
            body,
          });
          flash("success", "The conversation has been updated successfully.");
        } catch (e) {
          flash("error", e.message);
        }
        res.refreshWith(
          { modal: "", conversationId: "" },
          { url: "back", hash: "#_" }
        );
      }
    )
    .post(
      "/community-chat/direct-message-toggle",
      async ({ req, res, flash, api, locals, assert }) => {
        const { activeUserToRequest } = locals;
        const { _id: userId, pushAccountInfo } = activeUserToRequest;
        const { body } = req;
        const { directMessagesEnabled } = body;
        assert(pushAccountInfo, 400, "You need to be a PUSH user");

        const bodyToSend = {
          pushAccountInfo: {
            ...pushAccountInfo,
            directMessagesEnabled,
          },
        };
        try {
          await api(`user/${userId}`, {
            method: "PUT",
            body: bodyToSend,
          });

          flash(
            "success",
            "The direct message preference has been updated successfully."
          );
        } catch (e) {
          flash("error", e.message);
        }
        res.backDontScroll();
      }
    );
};

export default CommunityChat;
